<template>
  <div class="m-common__review__detail" id="base-review-detail">
    <ul>
      <li class="review__detail__rating" v-if=!isOfficialAccount>
        <span class="star-wrap star-size-14"><span :class="star | formatRatingClassName('star-')">{{ star | formatRating }}</span></span>
      </li>
      <li class="review__detail__timestamp">{{ created | formatRelativeDate }}</li>
    </ul>
    <dl class="review__detail__comment">
      <dt>
        <a :href="reviewDetailUrl" v-if="isLinkToDetail"><span class = "review__detail__comment-title">{{ caption }}</span></a>
        <template v-else>{{caption}} </template>
      </dt>
      <dd>
        <a :href="reviewDetailUrl" v-if="isLinkToDetail">
            <span :class="{'review__detail__comment-text':showReadMore}">{{ sliceDescription }}</span>
            <span v-if="showReadMore" class="read-more">続きを見る</span>
        </a>
        <template v-else>{{ description }}</template>
      </dd>
    </dl>
    <div class="review__detail__profile" v-if="isRenderUserInfo && nickname">
      <a :href="userReviewUrl" >
        <figure class="review__detail__image" :class="{'icon-checked': isOfficialAccount}">
          <span class="image-circle image-circle-size40">
            <img :src="iconLinkURL" alt="" @load="shapeUserIconToCircle">
          </span>
        </figure>
        <p>{{ nickname }}</p>
      </a>
    </div>
    <div class="review__detail__profile" v-if="isRenderUserInfo && !nickname">
      <a><figure class="review__detail__image" :class="{'icon-checked': isOfficialAccount}">
        <span class="image-circle image-circle-size40">
        <img :src="iconLinkURL" alt="" @load="shapeUserIconToCircle"></span></figure>
      <p>{{ nickname }}</p>
      </a>
    </div>
  </div>
</template>

<script>
import urls from '@/mixins/urls'
export default {
  name: 'BaseReviewDetail',
  mixins: [ urls ],
  props: {
    star: {
      type: Number,
      default: 0
    },
    caption: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    created: {
      type: String,
      default: ''
    },
    isRenderUserInfo: {
      type: Boolean,
      default: true
    },
    iconUrl: {
      type: String,
      default: ''
    },
    nickname: {
      type: String,
      default: ''
    },
    isLinkToDetail: {
      type: Boolean,
      default: false
    },
    reviewId: {
      type: Number,
      default: 0
    },
    accountStatus: {
      type: String,
      default: null
    }
  },
  computed: {
    userReviewUrl () {
      return this.getUserReviewUrl(this.nickname)
    },
    reviewDetailUrl () {
      const query = this.$store.state.storeReviews.query
      return this.getReviewDetailUrl(this.reviewId, query)
    },
    iconLinkURL () {
      return this.iconUrl ? this.iconUrl : this.getDefaultUserImageUrl()
    },
    sliceDescription () {
      return this.description.slice(0, 100)
    },
    showReadMore () {
      if (this.description.length >= 100 && this.isLinkToDetail) {
        return true
      } else {
        return false
      }
    },
    isOfficialAccount () {
      return this.accountStatus && this.accountStatus.length >= 1
    }
  },
  methods: {
    shapeUserIconToCircle (e) {
      var ua = navigator.userAgent.toLowerCase()
      var isIE = ua.match('msie') || ua.match('trident/7')
      if (isIE) {
        const w = e.currentTarget.naturalWidth
        const h = e.currentTarget.naturalHeight
        if (w > h) {
          window.$(e.currentTarget).addClass('fit-height')
        } else if (w < h) {
          window.$(e.currentTarget).addClass('fit-width')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseReviewDetail.vue